var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#CCD8E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13C12.8048 13.1952 12.4882 13.1952 12.2929 13L5.00004 5.70707C4.80478 5.51181 4.80478 5.19522 5.00004 4.99996V4.99996C5.1953 4.8047 5.51188 4.8047 5.70714 4.99996L13 12.2929C13.1953 12.4881 13.1953 12.8047 13 13V13Z",
    fill: "#003E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00004 13C4.80478 12.8048 4.80477 12.4882 5.00004 12.2929L12.2929 5.00004C12.4882 4.80478 12.8048 4.80478 13 5.00004V5.00004C13.1953 5.1953 13.1953 5.51188 13 5.70714L5.70714 13C5.51188 13.1953 5.1953 13.1953 5.00004 13V13Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9587cb111e5a815145541e29dcca332a.svg";
export { ForwardRef as ReactComponent };